import reduceReducers from 'reduce-reducers';

//Siblings reducers
import roleReducer from './role-reducer';

export default reduceReducers(roleReducer);
